import NcDialog from '@nextcloud/vue/components/NcDialog';
import NcButton from '@nextcloud/vue/components/NcButton';
import NcLoadingIcon from '@nextcloud/vue/components/NcLoadingIcon';
import { showError } from '@nextcloud/dialogs';
import { translate as t } from '@nextcloud/l10n';
import { api, Permission } from '../Common/Api';
import { sendFileToBBB } from '../filelist';
export default {
  name: 'SendFileDialog',
  components: {
    NcDialog,
    NcLoadingIcon,
    NcButton
  },
  props: {
    filename: {
      type: String,
      required: true
    },
    fileId: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: t('bbb', 'Send to BBB')
    }
  },
  data() {
    return {
      opened: false,
      loading: true,
      rooms: []
    };
  },
  created() {
    api.getRooms().then(rooms => {
      this.rooms = rooms.filter(room => room.permission === Permission.Admin);
      this.loading = false;
    });
  },
  methods: {
    t,
    onClose() {
      this.opened = false;
      this.$emit('close');
    },
    /*
    	La confirmation déclenche un événement 'confirm'.
    	Si la logique d'envoi est asynchrone côté parent, le parent peut gérer le flag `modelValue`/un loader.
    	Ici on active un loader visuel court pour l'UX puis on ferme la dialog.
    */
    onConfirm() {
      this.loading = true;
      try {
        this.$emit('confirm');
      } finally {
        // fermeture et reset loader (simulé court délai si nécessaire)
        this.loading = false;
        this.$emit('update:modelValue', false);
      }
    },
    sendFileToRoom(roomUid) {
      this.loading = true;
      sendFileToBBB(this.fileId, this.filename, roomUid).then(() => {
        this.loading = false;
        this.$emit('sent', roomUid);
        this.onClose();
      }).catch(() => {
        this.loading = false;
        showError(t('bbb', 'An error occurred while sending the file to the room.'));
      });
    }
  }
};